//@ts-nocheck
import { useState } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link';
import Image from 'next/image';
import { BailetsBlock } from '../../ModalCopy.styles';
import { CloseVideoIcon, LogoMartins } from '@assets/svgs';
import { CWriting } from '@data/copywriting';

type DiorpoisonProps = {
  isClosed?: () => void;
  showImg?: boolean | string;
  showMedia?: boolean | string;
};

export const Diorpoison = ({
  isClosed,
  showImg,
  showMedia
}: DiorpoisonProps) => {
  return (
    <>
      <BailetsBlock>
        <CloseVideoIcon
          animation="closeIcon"
          color="#000"
          isActive={isClosed}
        />
        <LogoMartins
          width={70}
          height={65}
          color="rgba(0,0,0,0.5)"
          animation="mansion"
        />

        <h3>DIOR</h3>
        <span style={{ marginBottom: '25px' }}>
          HYPNOTIC POISON - EAU DE PERFUM
        </span>
        {showImg && <Image src={showImg} width={1480} height={825} alt="" />}
        {showMedia && (
          <video controls={false} playsInline muted autoPlay loop>
            <source src={showMedia} type="video/mp4" />
          </video>
        )}
        <h3 style={{ marginTop: '25px' }}>{CWriting.copyWriting[0].title1}</h3>
        <h3>{CWriting.copyWriting[0].title2}</h3>
        <p>
          <b>
            Intense for an exceptional woman. Attract the power within you. FELL
            EMPOWERED.
          </b>
          <br />
          <br /> Step into a realm of allure and intrigue with Dior Hypnotic
          Poison. Designed by the talented Annick Menardo, this Oriental Vanilla
          fragrance enchants from the first note. Allow yourself to be
          captivated by the creamy richness of almond and coconut, creating an
          irresistible charm. The heart reveals a bouquet of seductive florals,
          including jasmine, lily-of-the-valley, and rose. The base wraps you in
          a cosy, sensual vanilla, sandalwood, and tonka bean.
          <br />
          <br />
          Housed in its signature red apple bottle, Hypnotic Poison transcends
          mere fragrance; it embodies a tantalizing promise of forbidden
          attraction. Embrace the epitome of luxury and seduction. Awaken your
          inner enchantress with Dior Hypnotic Poison—where passion intertwines
          with elegance, and desire knows no limits.
          <br />
          <br /> Feel the enchantment. Yield to the allure. Dior Hypnotic Poison
          is ready for you.
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h2 className="markTitle">Case study: Marketing Dior Hypnotic Poison</h2>
        <p style={{ width: '100%' }}>
          <b>Brand:</b> Christian Dior
          <br />
          <br />
          <b>Product:</b> Dior Hypnotic Poison Perfume
          <br />
          <br />
          <b>Objective:</b> Increase sales and brand awareness for Dior Hypnotic
          Poison in a highly competitive luxury perfume market.
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h2 className="markTitle">Challenge</h2>
        <p style={{ width: '100%' }}>
          <b>Market Saturation and Differentiation</b>
          <br />
          The opulent perfume industry is brimming with an array of exquisite
          fragrances. All are competing for the admiration of sophisticated
          clientele. Dior Hypnotic Poison. With its illustrious legacy and
          unique aroma, it has encountered considerable obstacles:
          <br />
          <br />
          <b>1- High Competition:</b> Competing against both established luxury
          brands and new niche perfumers.
          <br />
          <br />
          <b>2- Changing Consumer Preferences:</b> The modern consumer is
          increasingly influenced by social media, looking for personalized
          experiences and unique stories. <br />
          <br />
          <b>3- Perception Shift:</b> Younger audiences often perceive classic
          fragrances as outdated, preferring newer, trendier options.
        </p>
      </BailetsBlock>

      <BailetsBlock style={{ justifyContent: 'center' }}>
        <h2 className="markTitle">Solution</h2>
        <p style={{ width: '100%' }}>
          <b>Strategic Marketing Campaign</b>
          <br />
          To address these challenges, a multi-faceted marketing campaign was
          developed, focusing on the following key strategies:
          <br />
          <br />
          <b>1. Storytelling and Emotional Connection</b>
          <br />
          <b>Objective:</b> Reinvigorate the brand’s narrative to connect with
          both existing loyal customers and new, younger audiences.
          <br />
          <br />
          Execution:
          <br />
          <b>1- Narrative Development:</b> Crafted a compelling story that
          highlighted the mysterious and seductive nature of Hypnotic Poison.
          The story emphasized its enchanting qualities, positioning it as a
          timeless yet modern scent.
          <br />
          <br />
          <b>2- Content Creation:</b> Produced high-quality visual and written
          content that captured the essence of the perfume. This included short
          films, engaging social media posts, and immersive web experiences.
          <br />
          <br />
          <b>Example:</b> A mini-series of video ads featuring a modern femme
          fatale navigating through different sophisticated settings, with
          Hypnotic Poison as her invisible allure.
          <br />
          <br />
          <b>2. Influencer Collaborations</b>
          <br />
          <b>Objective:</b> Leverage the reach and authenticity of influencers
          to build credibility and drive engagement.
          <br />
          <br />
          Execution:
          <br />
          <b>1- Selecting Influencers:</b> Partnered with influencers who
          resonate with both Dior’s brand values and the target demographic.
          This included fashion icons, beauty gurus, and lifestyle influencers.
          <br />
          <br />
          <b>2- Creative Campaigns:</b> Developed creative campaigns where
          influencers shared personal stories of how Hypnotic Poison made them
          feel, creating an emotional and personal connection with their
          followers.
          <br />
          <br />
          <b>Example:</b> Influencers created content around the theme “My
          Hypnotic Moment,” sharing moments when the fragrance made them feel
          confident and alluring.
          <br />
          <br />
          <b>3. Interactive and Personalized Experiences</b>
          <br />
          <b>Objective:</b> Engage consumers through interactive and
          personalized experiences, making the fragrance feel bespoke and
          exclusive.
          <br />
          <br />
          Execution:
          <br />
          <b>1- Virtual Try-Ons:</b> Implemented augmented reality (AR)
          technology on the Dior website, allowing customers to virtually “try
          on” the perfume and see which notes match their personality and style.
          <br />
          <br />
          <b>2- Personalization Services:</b> Offered personalized engraving on
          bottles and custom gift-wrapping services to make the purchase
          experience special.
          <br />
          <br />
          <b>Example:</b> A dedicated section on the Dior website where
          customers could choose engraving options and see a preview of their
          personalized bottle.
          <br />
          <br />
          <b>4. Exclusive Launch Events and Pop-Ups</b>
          <br />
          <b>Objective:</b> Create buzz and exclusivity around the fragrance to
          attract media attention and drive word-of-mouth marketing.
          <br />
          <br />
          Execution:
          <br />
          <b>1- Exclusive Events:</b> Hosted exclusive launch parties in major
          cities with celebrity appearances and live performances, creating a
          high-end, glamorous image.
          <br />
          <br />
          <b>2- Pop-Up Stores:</b> Set up pop-up stores in strategic locations,
          offering immersive experiences where customers could explore the
          scent, learn about its ingredients, and purchase limited-edition
          bottles.
          <br />
          <br />
          <b>Example:</b> A series of pop-up stores in luxury shopping
          districts, designed as enchanting, mysterious environments reflecting
          the Hypnotic Poison theme.
        </p>
      </BailetsBlock>

      <BailetsBlock style={{ justifyContent: 'center' }}>
        <h2 className="markTitle">Results</h2>
        <p style={{ width: '100%' }}>
          <b>1- Increased Sales:</b> A 25% increase in sales over the first six
          months of the campaign, outperforming previous quarters.
          <br />
          <br />
          <b>2- Enhanced Brand Awareness:</b> Significant boost in brand
          awareness, with a 40% increase in social media mentions and
          engagement.
          <br />
          <br />
          <b>3- Positive Perception Shift:</b> Successfully attracted a younger
          demographic, with a 30% increase in purchases from consumers aged
          18-34.
          <br />
          <br />
          <b>4- Customer Loyalty:</b> Strengthened loyalty among existing
          customers, with a notable increase in repeat purchases and positive
          reviews.
        </p>
      </BailetsBlock>

      <BailetsBlock style={{ justifyContent: 'center' }}>
        <h2 className="markTitle">Conclusion</h2>
        <p style={{ width: '100%' }}>
          Through a well-crafted storytelling approach, strategic influencer
          collaborations, interactive experiences, and exclusive events, Dior
          Hypnotic Poison was able to overcome market saturation and shifting
          consumer preferences. The campaign not only boosted sales but also
          revitalized the brand's image, making Hypnotic Poison a desirable and
          timeless fragrance for both new and loyal customers.
        </p>
      </BailetsBlock>
    </>
  );
};
